import { Directive, input, TemplateRef, ViewContainerRef } from '@angular/core';
import { takeUntilDestroyed, toObservable } from '@angular/core/rxjs-interop';
import { UserRole } from '@examdojo/models/user';
import { UntilDestroy } from '@ngneat/until-destroy';
import { switchMap, tap } from 'rxjs';
import { UserQuery } from './user.query';

@UntilDestroy()
@Directive({
  selector: '[dojoIfUserHasRole]',
  exportAs: 'ifUserHasRole',
  standalone: true,
})
export class IfUserHasRoleDirective {
  constructor(
    private readonly viewContainer: ViewContainerRef,
    private readonly templateRef: TemplateRef<unknown>,
    private readonly userQuery: UserQuery,
  ) {
    toObservable(this.dojoIfUserHasRole)
      .pipe(
        switchMap((role) => this.userQuery.selectHasRoleOrHigher(role)),
        tap((isGranted) => {
          this.viewContainer.clear();
          if (isGranted) {
            this.viewContainer.createEmbeddedView(this.templateRef);
          }
        }),
        takeUntilDestroyed(),
      )
      .subscribe();
  }

  readonly dojoIfUserHasRole = input.required<UserRole>();
}
